"use client";

import {
  Slider,
  SliderContent,
  SliderItem,
  SliderNext,
  SliderPrevious,
} from "@workspace/frontend-ui";
import { Children } from "react";
import createItemKeyResolver from "./getUniqueItemKey";

type Props = {
  dir?: "ltr" | "rtl";
};

const GameRowCarousel: FC<Props> = ({ children, dir = "ltr" }) => {
  const items = Children.toArray(children);

  if (!items.length) {
    return null;
  }

  const resolveItemKey = createItemKeyResolver();

  return (
    <Slider dir={dir}>
      <SliderContent className="-ml-3" dir={dir}>
        {items.map((item) => (
          <SliderItem key={resolveItemKey(item)} className="basis-auto pl-3">
            {item}
          </SliderItem>
        ))}
      </SliderContent>
      <SliderPrevious className="left-0 -ml-3.75 z-2 hidden disabled:hidden! lg:inline-flex! bg-background! shadow" />
      <SliderNext className="right-0 -mr-3.75 z-2 hidden disabled:hidden! lg:inline-flex! bg-background! shadow" />
    </Slider>
  );
};

export default GameRowCarousel;
